import { useMutation, useQueryClient } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';

import { chatEndpoints } from './constants';
import { chatQueryKeys } from './queryKeys';

export const useDeleteChatMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (chatId: string) => {
      await fetchClient.DELETE(chatEndpoints.chat, {
        params: { path: { id: chatId } },
      });
    },
    onSuccess: (_data, chatId) =>
      queryClient.removeQueries({ queryKey: chatQueryKeys.detail(chatId) }),
    onSettled: () =>
      queryClient.invalidateQueries({ queryKey: chatQueryKeys.lists() }),
  });
};
